// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Placeholder for a dataflow with nothing on its canvas yet. A flat surface, not
   a per-dataflow tint: dataflows have no categories, so the only colour in this
   thumbnail is the node bars, which are keyed to node type. */
.kEmCTIVX04fO8NvE3zVE {
  width: 100%;
  height: 100%;
  background-color: var(--curio-kind-dataflow-bg);
}
`, "",{"version":3,"sources":["webpack://./src/components/DataflowThumbnail.module.css"],"names":[],"mappings":"AAAA;;8DAE8D;AAC9D;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;AACjD","sourcesContent":["/* Placeholder for a dataflow with nothing on its canvas yet. A flat surface, not\n   a per-dataflow tint: dataflows have no categories, so the only colour in this\n   thumbnail is the node bars, which are keyed to node type. */\n.emptyPreview {\n  width: 100%;\n  height: 100%;\n  background-color: var(--curio-kind-dataflow-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyPreview": `kEmCTIVX04fO8NvE3zVE`
};
export default ___CSS_LOADER_EXPORT___;
